export const STROKE_GEOM_BIN_TYPE = "-stroke";
export const FILL_GEOM_BIN_TYPE = "-fill";

export const geomBinTypes = ["", STROKE_GEOM_BIN_TYPE, FILL_GEOM_BIN_TYPE];
